import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=1f0149cb&scoped=true&"
import script from "./LayoutBasic.vue?vue&type=script&lang=js&"
export * from "./LayoutBasic.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBasic.vue?vue&type=style&index=0&id=1f0149cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0149cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VContainer,VIcon,VList,VListGroup,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VNavigationDrawer})
